import ReactSelect from "react-select";
import Previews from "./Dropzone";
import { Slider } from "@mui/material";

const Organs = ({
  handleChangeOrgan,
  month,
  handleFile,
  handleInstallmentMonth,
  costs,
}) => {
  const organs = JSON.parse(localStorage.getItem("splash")).organization;
  const monthToEn = {
    2: "two",
    3: "three",
    4: "four",
    5: "five",
    6: "six",
  };
  return (
    <div className={"portals"}>
      <div className={"containerSelect"}>
        <div className={"select"} dir="rtl">
          <span>تعداد ماه اقساط</span>
          <Slider
            defaultValue={2}
            valueLabelDisplay="auto"
            shiftStep={1}
            step={1}
            min={2}
            marks={[
              {
                value: 2,
                label: "2",
              },
              {
                value: 3,
                label: "3",
              },
              {
                value: 4,
                label: "4",
              },
              {
                value: 5,
                label: "5",
              },
              {
                value: 6,
                label: "6",
              },
            ]}
            dir="rtl"
            max={6}
            onChange={(e) => handleInstallmentMonth(e.target.value)}
          />
        </div>
        <div className={"select"}>
          <span>انتخاب شرکت قراردادی</span>
          <ReactSelect
            components={{
              IndicatorSeparator: () => null,
            }}
            classNamePrefix="selectBox"
            placeholder="شرکت"
            noOptionsMessage={() => "در حال لود ... "}
            onChange={(v) => {
              handleChangeOrgan(v);
            }}
            options={organs.map((organ) => ({
              label: organ.name,
              value: { id: organ.id, limit_price: organ.contract_limit },
            }))}
          />
        </div>
      </div>
      <div>
        <Previews handleFile={handleFile} />
      </div>
      <div className="agsat">
        <span>
          شما تعداد ماه اقساط {month} انتخاب کرده اید که مبلغ هر ماه به این صورت
          است
        </span>
        {costs?.agsat[monthToEn[month]]?.map((m, i) => (
          <span key={i}>
            قسط ماه {i + 1} :‌ {m?.toLocaleString()} تومان
          </span>
        ))}
      </div>
    </div>
  );
};

export default Organs;
